import { BrowserRouter, Route, Routes } from 'react-router';
import './App.css';
import Header from './components/Header'
import Home from './pages/Home';
import Footer from './components/Footer';
import Workflow from './pages/Workflow';
import Auth from './pages/Auth';
import Books from './pages/Books';
import History from './pages/History';
import Payment from './pages/Payment';
import PaymentResult from './pages/PaymentResult';
import VoiceRecords from './pages/VoiceRecords';
import RssSubscription from './pages/RssSubscription';

function App() {
  return (
    <div className="flex flex-col min-h-screen" data-name="app">
      <BrowserRouter>
        <Header />
        <main className="flex-grow" data-name="main-content">
            <Routes>
              <Route path='/' element={<Home />} />
              <Route path='/workflow' element={<Workflow />} />
              <Route path='/auth' element={<Auth />} />
              <Route path='/books' element={<Books />} />
              <Route path='/history' element={<History />} />
              <Route path='/payment' element={<Payment />} />
              <Route path='/payment-result' element={<PaymentResult />} />
              <Route path='/voices' element={<VoiceRecords />} />
              <Route path='/rss' element={<RssSubscription />} />
            </Routes>
        </main>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
